/**
 * Throw error in a type-impossible situation, ensuring that all supported types are covered.
 *
 * @example
 * type Animal = 'cat' | 'dog' | 'mouse';
 * const growl = (animal: Animal): string => {
 *   switch (animal) {
 *     case 'cat':
 *       return 'meow';
 *     case 'dog':
 *       return 'woof';
 *     default:
 *       // TYPE ERROR until branch for 'mouse' is added above
 *       throw new AbsurdError(animal, `Unexpected animal: ${animal}`);
 *   }
 * }
 */
export class AbsurdError extends Error {
  constructor(_absurdValue: never, message: string) {
    super(message);
  }
}
